module.exports = __webpack_public_path__ + "img/house-white.9761396d.svg";